module.exports = __webpack_public_path__ + "static/icons/icon-webcam--white-dec177e7ac94ebde69507a43a5534e70.svg";